module.exports = __webpack_public_path__ + "img/Fanta Orange Bottle .ad0d76d7.png";